import { TFunction } from 'i18next';
import { CAROUSEL_MAX_VIDEO_BYTES } from '@/features/scheduler/utils/carouselMedia';

export interface UploadConfig {
  accept: string;
  subtitle: string;
  titleName: string;
  maxSize?: number;
  multiple?: boolean;
}

export const getStoriesUploadConfig = (t: TFunction): UploadConfig => ({
  accept: '.mp4,.mov,.jpg,.jpeg,.png,.webp,.bmp,.gif',
  subtitle: t('upload.storiesSubtitle'),
  titleName: t('upload.storiesTitle'),
  maxSize: 100 * 1024 * 1024,
  multiple: false
});

export const getReelsUploadConfig = (t: TFunction): UploadConfig => ({
  accept: '.mp4,.mov',
  subtitle: t('upload.reelsSubtitle'),
  titleName: t('upload.reelsTitle'),
  maxSize: 300 * 1024 * 1024,
  multiple: false
});

export const getReelsCoverUploadConfig = (t: TFunction): UploadConfig => ({
  accept: '.jpg,.jpeg,.png,.webp,.bmp,.gif',
  subtitle: t('upload.reelsCoverSubtitle'),
  titleName: t('upload.reelsCoverTitle'),
  maxSize: 100 * 1024 * 1024,
  multiple: false
});

export const getFeedUploadConfig = (t: TFunction): UploadConfig => ({
  accept: '.jpg,.jpeg,.png,.webp,.bmp,.gif',
  subtitle: t('upload.feedSubtitle'),
  titleName: t('upload.feedTitle'),
  maxSize: 100 * 1024 * 1024,
  multiple: false
});

export const getCarouselUploadConfig = (t: TFunction): UploadConfig => ({
  accept: '.mp4,.mov,.jpg,.jpeg,.png,.webp,.bmp,.gif',
  subtitle: t('carousel.uploadSubtitle'),
  titleName: t('carousel.uploadTitle'),
  maxSize: CAROUSEL_MAX_VIDEO_BYTES,
  multiple: true,
});

export const getDefaultUploadConfig = (t: TFunction): UploadConfig => ({
  accept: '.mp4,.mov,.jpeg,.png',
  subtitle: t('upload.defaultSubtitle'),
  titleName: t('upload.defaultTitle'),
});